/**
 * Short vertical clips for “Nails in motion” on the home page and full gallery — videos in `public/videos/`.
 * Posters use `public/arts/` stills (decorative; not necessarily a frame from the clip).
 */

export type NailsInMotionVideo = {
  id: string
  src: string
  /** Concise description for screen readers */
  description: string
  /** Still from `public/arts/` until the video loads; also shown when reduced motion hides video */
  poster: string
}

export const nailsInMotionVideos: readonly NailsInMotionVideo[] = [
  {
    id: 'motion-1',
    src: '/videos/1.mp4',
    poster: '/arts/11.jpg',
    description: 'Salon clip: nail work and hands in motion',
  },
  {
    id: 'motion-2',
    src: '/videos/2.mp4',
    poster: '/arts/4.jpg',
    description: 'Salon clip: treatment moment and lighting',
  },
  {
    id: 'motion-3',
    src: '/videos/3.mp4',
    poster: '/arts/27.jpg',
    description: 'Salon clip: close-up detail and polish',
  },
  {
    id: 'motion-4',
    src: '/videos/4.mp4',
    poster: '/arts/18.jpg',
    description: 'Salon clip: atmosphere in the studio',
  },
  {
    id: 'motion-5',
    src: '/videos/5.mp4',
    poster: '/arts/22.jpg',
    description: 'Salon clip: service moment',
  },
  {
    id: 'motion-6',
    src: '/videos/6.mp4',
    poster: '/arts/30.jpg',
    description: 'Salon clip: detail and finish',
  },
  {
    id: 'motion-7',
    src: '/videos/7.mp4',
    poster: '/arts/14.jpg',
    description: 'Salon clip: hands and nails in motion',
  },
  {
    id: 'motion-8',
    src: '/videos/8.mp4',
    poster: '/arts/21.jpg',
    description: 'Salon clip: manicure in progress',
  },
  {
    id: 'motion-9',
    src: '/videos/9.mp4',
    poster: '/arts/9.jpg',
    description: 'Salon clip: polish and studio light',
  },
] as const
